import { LogLevel } from '@nts/std/utility';

export const environment = {
  production: true,
  baseAppUrl: 'https://ntsplacewebapp.ntsinformatica.it',
  authenticationAppUrl: 'https://ntsloginservice.ntsinformatica.it/auth/login',
  prefixApi: '/api',
  envType: 'DEV',
  appTitle: 'WebPlace - DEV',
  appSubTitle: '',
  logLevel: LogLevel.All,
  isEnterpriseBarrierRequired: false
};
